import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Avatar, BLACK_700, BLACK_900, Typography, getTestId, isValidObject, StateConfigContext, Button } from '@airtel/air-design-system';
import { Fragment, useContext, useState, useEffect } from 'react';
import { View } from 'react-native';
import { ListWidget } from '../list-widget';
import { TypographyWidget } from '../typography-widget';
import { getTermsAndConditionWidgetStyles } from './TermsAndConditionWidgetStyles';
export var TermsAndConditionWidgetComponent = props => {
  var _useContext = useContext(StateConfigContext),
    theme = _useContext.theme;
  var _props$dataArray = props.dataArray,
    dataArray = _props$dataArray === void 0 ? [] : _props$dataArray,
    heading = props.heading,
    subHeading = props.subHeading,
    _props$headingAndSubH = props.headingAndSubHeadingAlignment,
    headingAndSubHeadingAlignment = _props$headingAndSubH === void 0 ? 'center' : _props$headingAndSubH,
    imageUrl = props.imageUrl,
    title = props.title,
    _props$listDataArray = props.listDataArray,
    listDataArray = _props$listDataArray === void 0 ? [] : _props$listDataArray,
    style = props.style,
    singleListItemTopSpacing = props.singleListItemTopSpacing,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'TermsAndConditionWidget' : _props$testID,
    onUserAction = props.onUserAction,
    _props$collapsedState = props.collapsedState,
    collapsedState = _props$collapsedState === void 0 ? {} : _props$collapsedState;
  var shouldAddSafeSpace = !!heading || !!subHeading || !!title;
  var termsAndConditionWidgetStyles = getTermsAndConditionWidgetStyles();
  var _useState = useState(false),
    isCollapsibleOpen = _useState[0],
    setIsCollapsibleOpen = _useState[1];
  var _useState2 = useState(listDataArray),
    collapsedListDataArray = _useState2[0],
    setCollapsetListDataArray = _useState2[1];
  useEffect(() => {
    setCollapsedListDataArrayFunc();
  }, [isCollapsibleOpen]);
  var onTogglePress = () => {
    setIsCollapsibleOpen(!isCollapsibleOpen);
  };
  var setCollapsedListDataArrayFunc = () => {
    if ((listDataArray === null || listDataArray === void 0 ? void 0 : listDataArray.length) > (collapsedState === null || collapsedState === void 0 ? void 0 : collapsedState.collapsibleLimit) && (collapsedState === null || collapsedState === void 0 ? void 0 : collapsedState.collapsibleLimit)) {
      var collapsibleLimit = isCollapsibleOpen ? listDataArray === null || listDataArray === void 0 ? void 0 : listDataArray.length : collapsedState === null || collapsedState === void 0 ? void 0 : collapsedState.collapsibleLimit;
      var _collapsedListDataArray = listDataArray && listDataArray.length && listDataArray.slice(0, collapsibleLimit);
      setCollapsetListDataArray(_collapsedListDataArray);
    }
  };
  return _jsxs(View, Object.assign({
    style: style
  }, getTestId(testID), {
    children: [!!imageUrl && _jsx(Avatar, {
      size: "sm",
      imageUrl: imageUrl,
      variant: "image",
      outerContainerStyles: termsAndConditionWidgetStyles.avatar
    }), !!heading && _jsx(Typography, {
      textAlignment: headingAndSubHeadingAlignment,
      color: BLACK_900,
      type: "body-single-line-md-bold",
      text: heading
    }), !!subHeading && _jsx(Typography, {
      textAlignment: headingAndSubHeadingAlignment,
      color: BLACK_700,
      type: "body-para-sm",
      text: subHeading
    }), !!title && _jsx(Typography, {
      color: BLACK_700,
      type: "body-single-line-sm-bold",
      style: shouldAddSafeSpace && termsAndConditionWidgetStyles.tncTitle,
      text: title
    }), (dataArray === null || dataArray === void 0 ? void 0 : dataArray.length) > 0 && _jsx(View, Object.assign({
      style: shouldAddSafeSpace && termsAndConditionWidgetStyles.listTopSpace
    }, {
      children: dataArray === null || dataArray === void 0 ? void 0 : dataArray.map((singleData, index) => {
        return _jsxs(Fragment, {
          children: [isValidObject(singleData === null || singleData === void 0 ? void 0 : singleData.title) && _jsx(TypographyWidget, Object.assign({
            color: BLACK_700,
            type: "body-single-line-sm-bold"
          }, singleData === null || singleData === void 0 ? void 0 : singleData.title, {
            style: [index !== 0 && termsAndConditionWidgetStyles.topMargin, termsAndConditionWidgetStyles.bottomMargin],
            onUserAction: onUserAction
          })), isValidObject(singleData === null || singleData === void 0 ? void 0 : singleData.subTitle) && _jsx(TypographyWidget, Object.assign({
            color: BLACK_700,
            type: "body-para-xs"
          }, singleData === null || singleData === void 0 ? void 0 : singleData.subTitle, {
            onUserAction: onUserAction
          }))]
        }, "terms-and-condition_" + index);
      })
    })), isValidObject(collapsedListDataArray) && _jsxs(_Fragment, {
      children: [_jsx(ListWidget, {
        dataArray: collapsedListDataArray,
        style: shouldAddSafeSpace && termsAndConditionWidgetStyles.listTopSpace,
        topSpacing: singleListItemTopSpacing,
        onUserAction: onUserAction
      }), (listDataArray === null || listDataArray === void 0 ? void 0 : listDataArray.length) > (collapsedState === null || collapsedState === void 0 ? void 0 : collapsedState.collapsibleLimit) && _jsx(Button, Object.assign({
        title: isCollapsibleOpen ? collapsedState.expandedCtaText : collapsedState.collapsedCtaText,
        buttonType: "tertiary",
        style: termsAndConditionWidgetStyles.ctaStyles,
        iconName: isCollapsibleOpen ? collapsedState.expandedCtaIcon : collapsedState.collapsedCtaIcon,
        theme: theme,
        iconPosition: "right",
        onPress: onTogglePress
      }, isCollapsibleOpen ? props === null || props === void 0 ? void 0 : props.expandedCtaAccessibilityProps : props === null || props === void 0 ? void 0 : props.collapsedCtaAccessibilityProps))]
    })]
  }));
};
TermsAndConditionWidgetComponent.genericRendererKey = 'AirTermsAndConditionWidget';